import { render, staticRenderFns } from "./BinaryDraggableQuestion.vue?vue&type=template&id=191c2c21&"
import script from "./BinaryDraggableQuestion.vue?vue&type=script&lang=js&"
export * from "./BinaryDraggableQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports